import { Skeleton } from '@material-ui/lab';
import { Grid } from '@mui/material';
import React, { useState } from 'react';
import HorizontalBarCard from 'src/App/Dashboards/Market/Components/Cards/HorizontalBar';
import { parseGuest } from 'src/utils/functions';

const GuestLanguageCard = ({
  graph,
  isDisabled,
  handleOnSampleClick,
  matches,
  userTailorMarketAccess,
  tooltipSuffix,
  warningTextComponent,
  setSelectedGraphExportDetails,
}: {
  graph;
  isDisabled: boolean;
  handleOnSampleClick: any;
  matches: boolean;
  userTailorMarketAccess: boolean;
  tooltipSuffix?: string;
  warningTextComponent: any;
  setSelectedGraphExportDetails: any;
}) => {
  const GRAPH_LIMIT = 5;
  const [graphLimit, setGraphLimit] = useState<number>(GRAPH_LIMIT);
  const dummyData = {
    en: 97.6,
    fr: 1.1,
    de: 0.7,
    es: 0.2,
    it: 0.0,
    ko: 0.0,
    no: 0.0,
    da: 0.0,
    nl: 0.0,
    cs: 0.0,
  };

  const onCTAClick = () => {
    setGraphLimit(prevLimit => (prevLimit === GRAPH_LIMIT ? -1 : GRAPH_LIMIT));
  };

  return (
    <>
      <HorizontalBarCard
        title="Top Guest Spoken Languages"
        data={isDisabled ? dummyData : parseGuest(graph.data?.guest_origin?.Languages)}
        color="#58C0A9"
        unit="%"
        isDisabled={isDisabled}
        handleOnSampleClick={handleOnSampleClick}
        graphLimit={graphLimit}
        onCTAClick={onCTAClick}
        matches={matches}
        userTailorMarketAccess={userTailorMarketAccess}
        tooltipSuffix={tooltipSuffix}
        parent="guest_spoken_languages"
        warningTextComponent={warningTextComponent}
        setSelectedGraphExportDetails={setSelectedGraphExportDetails}
      />
    </>
  );
};

export default GuestLanguageCard;
